import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NavController } from '@ionic/angular';
import { IonPopover } from '@ionic/angular/common';

export interface PropositionMenuOption {
  id?: string;
  name?: string;
  mine?: boolean;
  expand?: string;
  handler?: () => void;
  icon?: string;
  separatorName?: string;
  separatorClassess?: string;
  cssClass?: string;
  cssIconClass?: string;
}

@Component({
  selector: 'ark-lib-proposition-menu',
  templateUrl: './proposition-menu.component.html',
  styleUrl: './proposition-menu.component.css',
})
export class PropositionMenuComponent {
  @ViewChild('popoverRef') popoverRef!: IonPopover;
  id = Math.random().toString(16).slice(2);
  @Input() options: PropositionMenuOption[] = [];

  @Input() propMenu!: ElementRef<HTMLElement>;

  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  open = false;
  @Input() mine!: boolean;

  constructor(private navController: NavController) {}

  goTo(event: Event, option: PropositionMenuOption) {
    this.popoverRef.dismiss();
    this.open = false;
    event.preventDefault();
    event.stopPropagation();

    setTimeout(() => {
      if (option.handler) {
        option.handler();
      }
    });
    //

    return;
  }
  toggle(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.open = !this.open;

    if (this.open) this.opened.emit();
    if (!this.open) this.closed.emit();
  }
  dismiss(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.open = false;
  }
}
